import { configureStore } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import filterReducer from "./state/filter"
import mapReducer from './state/map'
import legendReducer from './state/legend'

export const store = configureStore({
    reducer: {
        filter: filterReducer,
        map: mapReducer,
        legend: legendReducer
    },
})

export type RootState = ReturnType<typeof store.getState>
type AppDispatch = typeof store.dispatch
type DispatchFunc = () => AppDispatch
export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector